import { actions as collection } from '@/plugins/Collection'

export default collection.toOptions({
  admin: 'Admin/User',
  borrower: 'Borrower',
  investor: 'Investor'
})
